// extracted by mini-css-extract-plugin
module.exports = {"icon":"OperatorLogo_icon__S6cS7"};